import axios, { AxiosResponse } from 'axios'

import { env } from '@js/utils/env'
import gql from '@js/api/utils/gql'
import getStoreName from '@js/api/utils/getStoreName'
import { Country } from '@js/api/types/address/Country'

interface GetCountriesResponse {
  data: {
    countries: Country[]
  }
}

export const getCountriesQuery = gql`
  query {
    countries {
      id
      full_name_english
      two_letter_abbreviation
      available_regions {
        id
        code
        name
      }
    }
  }
`

export const getCountries = async (): Promise<Country[]> => {
  const { data }: AxiosResponse<GetCountriesResponse> = await axios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    headers: {
      'Content-Type': 'application/json',
      Store: getStoreName(),
    },
    data: {
      query: getCountriesQuery,
    },
  })

  return data.data.countries
}
